const pageNameKey = "machineStructurePanelControlBar";

export const machineStructurePanelControlBarEn = {
  [pageNameKey]: {
    createFolder: "Create Folder",
    renameFolder: "Rename Folder",
    delete: "Delete selection",
    dataAcquisition: "Data Acquisition",
    openBlueprintDashboardSetup: "Open Dashboard Setup",
    dashboard: "Dashboard",
  },
};

export const machineStructurePanelControlBarPtBr = {
  [pageNameKey]: {
    createFolder: "Criar pasta",
    renameFolder: "Renomear pasta",
    delete: "Excluir seleção",
    dataAcquisition: "Aquisição de Dados",
    openBlueprintDashboardSetup: "Abrir configuração do painel",
    dashboard: "Dashboard",
  },
};

export const machineStructurePanelControlBarDe = {
  [pageNameKey]: {
    createFolder: "Ordner erstellen",
    renameFolder: "Ordner umbenennen",
    delete: "Auswahl löschen",
    dataAcquisition: "Datenakquise",
    openBlueprintDashboardSetup: "Dashboard Setup öffnen",
    dashboard: "Dashboard",
  },
};

export const machineStructurePanelControlBarZhHans = {
  [pageNameKey]: {
    createFolder: "创建文件夹",
    renameFolder: "重命名文件夹",
    delete: "删除选中项",
    dataAcquisition: "数据采集",
    openBlueprintDashboardSetup: "打开仪表板设置",
    dashboard: "仪表板",
  },
};

export const machineStructurePanelControlBarIt = {
  [pageNameKey]: {
    createFolder: "Crea cartella",
    renameFolder: "Rinomina cartella",
    delete: "Cancella selezione",
    dataAcquisition: "Acquisizione dei dati",
    openBlueprintDashboardSetup: "Apri configurazione dashboard",
    dashboard: "Dashboard",
  },
};

export const machineStructurePanelControlBarEs = {
  [pageNameKey]: {
    createFolder: "Crear carpeta",
    renameFolder: "Renombrar carpeta",
    delete: "Eliminar selección",
    dataAcquisition: "Adquisición de datos",
    openBlueprintDashboardSetup: "Abrir configuración del panel",
    dashboard: "Panel",
  },
};

export const machineStructurePanelControlBarNl = {
  [pageNameKey]: {
    createFolder: "Map aanmaken",
    dashboard: "Dashboard",
    dataAcquisition: "Gegevensverzameling",
    delete: "Selectie verwijderen",
    openBlueprintDashboardSetup: "Dashboardinstelling openen",
    renameFolder: "Map hernoemen",
  },
};

export const machineStructurePanelControlBarTr = {
  [pageNameKey]: {
    createFolder: "Klasör Oluştur",
    dashboard: "Kontrol Paneli",
    dataAcquisition: "Veri Toplama",
    delete: "Seçimi sil",
    openBlueprintDashboardSetup: "Kontrol Paneli Kurulumunu Aç",
    renameFolder: "Klasörü Yeniden Adlandır",
  },
};
